module.exports = __webpack_public_path__ + "static/media/splashscreen-animation.627d4514bd5598bd5497ff102fab23fff8fb7110032c47106547e9a93bcc03ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/splashscreen-animation.png
// module id = 2166
// module chunks = 204